module.exports = __webpack_public_path__ + "img/googlee.fd4b2587.jpg";